import values from 'lodash/values';
import uniqWith from 'lodash/uniqWith';

import {
    getFlashMessages as getFlashMessagesFromService,
    createFlashMessage as createFlashMessageFromService
} from '../../../services/api/flashMessages';
import {
    FLASH_MESSAGE_TYPE_SUCCESS,
    FLASH_MESSAGE_TYPE_ERROR,
    SPECIAL_COUPON_ERROR_HEADER
} from '../../../config/constants';
import types from './types';
import * as selectors from './selectors';

export const showFlashMessage = (type, text) => ({
    type: types.SHOW_FLASH_MESSAGE,
    payload: { type, text }
});

export const hideFlashMessage = () => ({
    type: types.HIDE_FLASH_MESSAGE
});

export const showHeaderFlashMessage = (type, text, customIcon, clickCallback) => ({
    type: types.SHOW_HEADER_FLASH_MESSAGE,
    payload: {
        type,
        text,
        customIcon,
        clickCallback
    }
});

export const hideHeaderFlashMessage = () => ({
    type: types.HIDE_HEADER_FLASH_MESSAGE
});

export const showHeaderSuccessFlashMessage = text => showHeaderFlashMessage(FLASH_MESSAGE_TYPE_SUCCESS, text);

export const showHeaderErrorFlashMessage = text => showHeaderFlashMessage(FLASH_MESSAGE_TYPE_ERROR, text);

// TODO Utilize REQUEST/SUCCESS/ERROR types pattern here in async call
export const fetchFlashMessages = (clientId, token) => (dispatch) => {
    dispatch({
        type: types.FETCH_FLASH_MESSAGES.REQUEST
    });

    return getFlashMessagesFromService(clientId, token)
        .then(result => {
            const messages = values(result);
            if (!messages.length) {
                return Promise.resolve([]);
            }

            // TODO The whole construction looks unclear: uniq, map, dispatch
            uniqWith(messages, (a, b) => {
                return ((a.type === b.type) && ((a.message && b.message && a.message === b.message)
                    || (a.text && b.text && a.text === b.text)));
            }).map(message => {
                if (message.type === FLASH_MESSAGE_TYPE_SUCCESS || message.message === SPECIAL_COUPON_ERROR_HEADER) {
                    dispatch({
                        type: types.SHOW_HEADER_FLASH_MESSAGE,
                        payload: message
                    });
                }
                else {
                    if (!message.text) {
                        message.text = message.message || '';
                    }
                    dispatch({
                        type: types.SHOW_FLASH_MESSAGE,
                        payload: message
                    });
                }

                return message;
            });

            return Promise.resolve(messages);
        })
        .catch(() => {
            return Promise.resolve([]);
        });
};

// TODO Get rid of Promise.resolve and Promise.reject
export const createFlashMessage = (type, message) => (dispatch) => {
    dispatch({
        type: types.CREATE_FLASH_MESSAGES.REQUEST
    });

    return createFlashMessageFromService({ type, message })
        .then(messages => {
            dispatch({
                type: types.CREATE_FLASH_MESSAGES.SUCCESS
            });

            return Promise.resolve(messages);
        })
        // TODO make payload error.message
        .catch(error => {
            dispatch({
                type: types.CREATE_FLASH_MESSAGES.ERROR,
                payload: error
            });

            return Promise.reject(error);
        });
};

// TODO Move this logic to reducer and leave plain action here
export const removeSeenMessages = () => (dispatch, getState) => {
    const flashMessages = selectors.getFlashMessages(getState());
    const notSeenMessages = [];
    flashMessages.map(message => {
        if (!message.seen) {
            return notSeenMessages.push(message);
        }

        return false;
    });
    dispatch({
        type: types.REMOVE_SEEN_FLASH_MESSAGES,
        payload: notSeenMessages
    });
};
